import React from 'react'
// containers
import DataPrivacy from 'components/PageComponents/Settings/DataPrivacy'

const DataPrivacyPage: React.FC = () => <DataPrivacy />

export default DataPrivacyPage
